<body class="ltr  leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class=" d-flex align-items-center pl-3">
                                                <div >
                                                    <h3 class="main-content-label mb-1"><b>
                                                        Student Complaint Form
                                                        </b></h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3"></div>
                                        <div class="col-md-2 prpl">
                                            <button id="addBtn" type="button"
                                                class="btn btn-primary btn-icon-text "
                                                (click)="addnewrecord()">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 5px;">
                                                    Add New
                                                </span>
                                            </button>
                                    </div>
                                    </div>
                                    <hr class="mt-2">
                                    <div class="table-responsive table-container">
                                        <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th class="f600" text-center>
                                                        Sr No.
                                                    </th>
                                                    <th class="f600" text-center>
                                                        Department
                                                    </th>
                                                    <th class="f600">
                                                        Grievance  Title
                                                    </th>
                                                    <th class="f600">
                                                        Grievance  Date
                                                    </th>
                                                    <th class="f600">
                                                        Status
                                                    </th>
                                                    <th class="f600 text-center">
                                                        View
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let complaint of complaintList; let i = index;">
                                                     <td>
                                                        {{ i + 1 }}
                                                        </td>
                                                        <td>
                                                            {{complaint.DepartmentName}}
                                                           </td>
                                                    <td>
                                                        {{complaint.GrievanceTitle}}
                                                    </td>
                                                    <td>
                                                        <!-- {{complaint.CreatedAt}} -->
                                                        {{ convertUTCToIST(complaint.CreatedAt) }}
                                                    </td>
                                                    <td>
                                                        {{complaint.CdDesc}}
                                                    </td>
                                                    <td class="text-center">
                                                        <a class="floating" title="Edit"
                                                        (click)="details(complaint)">
                                                                <i class="fa fa-eye eye"></i> </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>
